import { customElement, property, state } from "lit/decorators.js";

import { css, html } from "lit";
import { consume } from "@lit/context";
import { IFilterContext, filterContext } from "./filterContext";
import { LitElementBase } from "../LitElementBase";

@customElement("ehm-filter-searchfield")
export class FilterSearchField extends LitElementBase {

  static styles = css`
    :host {
      display: block;
    }
  `;

  @state()
  @consume({ context: filterContext, subscribe: true })
  private context?: IFilterContext;

  @property({ type: Boolean, attribute: "instant-search" })
  private instantSearch = false;

  private _debounceHandle: number | undefined;

  connectedCallback(): void {
    super.connectedCallback();
    this.querySelector("input[type=\"search\"]")?.addEventListener("input", this.handleInput);
  }

  disconnectedCallback(): void {
    this.removeEventListener("input", this.handleInput);
    if (this._debounceHandle) {
      window.clearTimeout(this._debounceHandle);
      this._debounceHandle = undefined;
    }
    super.disconnectedCallback();
  }

  private handleInput = (e: Event) => {
    if (!this.instantSearch) return;
    if (this._debounceHandle) window.clearTimeout(this._debounceHandle);
    // Abort any ongoing fetch while we wait for debounce
    this.context?.abortFetch?.();
    this._debounceHandle = window.setTimeout(() => {
      this._submitForm();
    }, 300);
  };

  private _submitForm() {
    this.context?.currentForm?.requestSubmit();
  }

  protected render() {
    return html`
      <slot>

      </slot>
    `;
  }
}